import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  totalCount: 0,
  entities: null,
  lastError: null,
  listLoading: false,
  actionsLoading: false,
  selectedIssue: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const issuesSlice = createSlice({
  name: "issues",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    setIssues: (state, action) => {
      const { items, totalItems } = action.payload.data;
      state.entities = items || null;
      state.totalCount = totalItems || 0;
      state.listLoading = false;
    },
    setSelectedIssue: (state, action) => {
      state.selectedIssue = action.payload?.data;
      state.actionsLoading = false;
    },
  },
});
